import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AppAdmins from "../pages/dashboardPage/adminOptions/appAdmins/AppAdmins";
import ControlAds from "../pages/dashboardPage/adminOptions/controlAds/ControlAds";
import RolesPermissions from "../pages/dashboardPage/adminOptions/rolesPermissions/RolesPermissions";
import Statistics from "../pages/dashboardPage/adminOptions/statistics/Statistics";

// Tab id (permissionCatalog "admin-options") → its page.
const TAB_PAGES = {
  statistics: Statistics,
  "app-admins": AppAdmins,
  "control-ads": ControlAds,
  roles: RolesPermissions,
};

const AdminOptionsNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("admin-options", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default AdminOptionsNavigator;
